import React from 'react';
import alert from '../assets/alert.png';

const DeleteDevice = ({ isOpen, onClose, onConfirm,deleteConfirm }) => {
  console.log(deleteConfirm,"llllllllllll")
  return (
    isOpen && (
      <div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50'>
        <div className='bg-white rounded-lg shadow-lg w-[35%] p-6 relative'>
          {/* Alert image centered above text */}
          <div className='flex justify-center mb-4'>
            <img src={alert} alt="Alert" className='h-10 w-10' />
          </div>
          
          <h2 className='text-center text-md font-inter font-medium mb-6'>
            Are you sure, you want to delete {deleteConfirm} Device?
          </h2>
          
          <div className='flex justify-center'>
            <button 
              onClick={onConfirm} 
              className='bg-red-800 text-white px-4 py-1 text-[14px] rounded mr-4 hover:bg-red-700'
            >
              Yes, Delete
            </button>
            <button 
              onClick={onClose} 
              className='bg-gray-300 text-black px-4 py-1 text-[14px] rounded hover:bg-gray-400'
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default DeleteDevice;